export default {
	sentryDsn:
		'https://9bb662259ce5b5d02579b2f2a6e3f9c8@o4510459761197056.ingest.de.sentry.io/4510515598065744',
	sentryTracingDomains: [
		/^https:\/\/.*\.monthio\.com\/api/,
		/^https:\/\/monthio\.northeurope\.cloudapp\.azure\.com/,
	],
	openReplayProject: 'aFoICSlbhgKQUqaAdR71',
	pensionInfoWindowUrl: `https://test-pension.monthio.com/api/v1/pensions-info/LoginTicket/{pensionSessionId}`,
}
